import script from "./TagAssignmentRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TagAssignmentRow.vue?vue&type=script&setup=true&lang=js"

import "./TagAssignmentRow.vue?vue&type=style&index=0&id=bb7c24e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7c24e0"]])

export default __exports__